// class AmazonCollectionCart {
//     constructor() {
        
//         this.loading = false;
//         this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
//         if (!this.cards.length) return;
//         console.log("Amazon Cart Initialized");
//         this.init();

//         document.addEventListener("cart:refresh", () => {
//             this.sync();
//         });

//         document.addEventListener("cart:updated", () => {
//             this.sync();
//         });
//     }

//     async sync() {
//         await this.loadCart();
//         this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
//         this.cacheCards();
//         this.renderProducts();
//     }

//     async init() {
//         console.log("Init amazon called");
//         await this.loadCart();
//         this.cacheCards();
//         this.renderProducts();
//         this.bindEvents();
//         this.cards.forEach(card => {
//             card.classList.add("amazon-ready");
//         });
//     }

//     async loadCart() {
//         const response = await fetch('/cart.js');
//         this.cart = await response.json();
//         console.log(this.cart);
//     }

//     async refreshCartUI() {
//         const response = await fetch('?section_id=helper-cart');
//         const html = await response.text();
//         const doc = new DOMParser().parseFromString(html, 'text/html');

//         // Header Count
//         document.querySelectorAll('[data-header-cart-count]').forEach(el => {
//             const count = doc.querySelector('#AjaxCartForm [data-cart-count]');
//             if (count) {
//                 el.textContent = count.textContent;
//             }

//         });

//         // Header Total
//         document.querySelectorAll('[data-header-cart-total]').forEach(el => {
//             const total = doc.querySelector('#AjaxCartForm [data-cart-total]');
//             if (total) {
//                 el.textContent = total.textContent;
//             }
//         });
//     }

//     async refresh() {
//         console.log("Refresh started");
//         await Promise.all([
//             this.loadCart(),
//             this.refreshCartUI()
//         ]);
//         console.log("Cart after load:", this.cart);
//         this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
//         this.cacheCards();
//         this.renderProducts();
//         console.log("Refresh finished");
//     }

//     async addItem(form) {

//         try {
//             const variantInput = form.querySelector('input[name="id"]');
//             if (!variantInput) {throw new Error("Variant ID not found");}
//             const variantId = Number(variantInput.value);
//             const properties = {};

//             form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(field => {
//                 const match = field.name.match(/^properties\[(.+)\]$/);
//                 if (!match) return;
//                 const propertyName = match[1];
//                 properties[propertyName] = field.value;
//             });

//             console.log("Adding product:", {
//                 variantId,
//                 properties
//             });

//             const response = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Accept': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     id: variantId,
//                     quantity: 1,
//                     properties: properties
//                 })
//             });

//             const data = await response.json();
//             console.log("Add to cart response:", data);
//             if (!response.ok) {
//                 throw new Error(data.description || 'Failed to add item');
//             }
//             await this.refresh();
//         } catch (error) {
//             console.error('Amazon Add Item Error:', error);
//         } finally {
//             this.loading = false;
//             document.body.classList.remove("amazon-cart-loading");
//         }
//     }

//     async changeQuantity(variantId, quantity) {
//         const item = this.getCartItem(variantId);
//         if (!item) {
//             console.warn("Cart item not found:", variantId);
//             return;
//         }

//         console.log("Changing cart quantity:", {
//             key: item.key,
//             variantId: variantId,
//             oldQty: item.quantity,
//             newQty: quantity
//         });

//         try {
//             const response = await fetch('/cart/change.js',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         id: item.key,
//                         quantity: quantity
//                     })
//                 }
//             );

//             const data = await response.json();
//             console.log("Cart change response:", data);
//             if (!response.ok) {
//                 throw new Error(data.description || 'Failed to update cart quantity');
//             }

//             this.cart = data;
//             await this.refreshCartUI();
//             this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
//             this.cacheCards();
//             this.renderProducts();
//             setTimeout(() => {
//                 this.showNextModal();
//             }, 1500);
//         } catch (error) {
//             console.error('Amazon Quantity Update Error:', error);
//         } finally {
//             this.loading = false;
//             document.body.classList.remove("amazon-cart-loading");
//             document.querySelectorAll(".amazon-quantity-loading").forEach(wrapper => {
//                 wrapper.classList.remove("amazon-quantity-loading");
//                 const select = wrapper.querySelector(".amazon-qty-select");
//                 if (select) {
//                     select.disabled = false;
//                 }
//             });
//         }
//     }

//     async handleClick(e) {
//         if (this.loading) return;
//         this.loading = true;
//         document.body.classList.add("amazon-cart-loading");
//         const minusBtn = e.target.closest('.amazon-minus');
//         const plusBtn = e.target.closest('.amazon-plus');
//         if (!minusBtn && !plusBtn) {
//             return;
//         }
//         e.preventDefault();
//         const wrapper = e.target.closest('.amazon-button-wrapper');
//         if (!wrapper) return;
//         const form = wrapper.closest('form');
//         if (!form) return;
//         const variantInput = form.querySelector('input[name="id"]');
//         if (!variantInput) return;
//         const variantId = Number(variantInput.value);
//         const currentQty = this.getCartQuantity(variantId);
//         if (minusBtn) {
//             const newQty = Math.max(0, currentQty - 1);
//             console.log('Minus:', variantId, currentQty, '→', newQty);
//             await this.changeQuantity(variantId, newQty);
//             return;
//         }

//         if (plusBtn) {
//             const newQty = currentQty + 1;
//             console.log('Plus:', variantId, currentQty, '→', newQty);
//             await this.changeQuantity(variantId, newQty);
//             return;
//         }

//     }

//     bindEvents() {
//         if (this.eventsBound) return;
//         this.eventsBound = true;

//         // ==========================================
//         // QUICK BUY / ADD TO CART
//         // ==========================================
//         document.addEventListener("click", async (e) => {
//             const button = e.target.closest(".quick_buy_atc_amazon button[type='submit']");
//             if (!button) return;
//             e.preventDefault();
//             e.stopPropagation();
//             e.stopImmediatePropagation();
//             if (this.loading) return;
//             const form = button.closest("form");
//             if (!form) return;
//             const variantInput = form.querySelector('input[name="id"]');
//             if (!variantInput) return;
//             const variantId = Number(variantInput.value);
//             button.classList.add("amazon-button-loading");
//             this.loading = true;
//             document.body.classList.add("amazon-cart-loading");
//             await this.addItem(form);
//         }, true);

//         // ==========================================
//         // QUANTITY SELECT CHANGE
//         // ==========================================
//         document.addEventListener("change", async (e) => {
//             const select = e.target.closest(".quick_buy_atc_amazon .amazon-qty-select");
//             if (!select) return;
//             e.stopPropagation();
//             if (this.loading) return;
//             const wrapper = select.closest(".amazon-button-wrapper");
//             if (!wrapper) return;
//             const form = wrapper.closest("form");
//             if (!form) return;
//             const variantInput = form.querySelector('input[name="id"]');
//             if (!variantInput) return;
//             const variantId = Number(variantInput.value);
//             const newQty = parseInt(select.value, 10);
//             if (isNaN(newQty)) return;
//             console.log("SELECT CHANGED:", {
//                 variantId: variantId,
//                 newQty: newQty
//             });

//             // Add loading state immediately
//             wrapper.classList.add("amazon-quantity-loading");
//             select.disabled = true;
//             this.loading = true;
//             document.body.classList.add("amazon-cart-loading");

//             // Let browser render loader before fetch
//             await new Promise(resolve => requestAnimationFrame(resolve));
//             await this.changeQuantity(variantId, newQty);
//         });
//     }

//     showNextModal() {
//         const $closeBtn = $(".close.quick-view-product-close");
//         if ($closeBtn.length) {
//             $closeBtn.trigger("click");
//         }
//         $(document.body).find(".close.quick-view-product-close").trigger("click");
//         document.body.classList.add("popup_next_open");

//         const modalNext = document.getElementById("nextModal");

//         if (modalNext) {
//             modalNext.style.visibility = "visible";
//             modalNext.style.opacity = "1";
//         }
//     }

//     cacheCards() {
//         this.products = [];

//         this.cards.forEach(card => {
//             const form = card.querySelector('form');
//             if (!form) return;

//             const variantInput = form.querySelector('input[name="id"]');
//             if (!variantInput) return;

//             const button = form.querySelector('[type="submit"]');
//             const inventory = Number(variantInput.dataset.inventory || 0);
//             const inventoryManaged = variantInput.dataset.inventoryManaged === 'true';
//             const inventoryPolicy = variantInput.dataset.inventoryPolicy;
//             let maxQty;

//             if (inventoryManaged && inventoryPolicy !== 'continue') {
//                 maxQty = Math.max(0, inventory);
//             } else {
//                 maxQty = 100;
//             }

//             this.products.push({
//                 card,
//                 form,
//                 button,
//                 variantId: Number(variantInput.value),
//                 maxQty
//             });
//         });

//         console.log("Amazon Products:", this.products);
//     }

//     getCartItem(variantId) {
//         return this.cart.items.find(item => Number(item.id) === Number(variantId));
//     }

//     getCartQuantity(variantId) {
//         const item = this.getCartItem(variantId);
//         return item ? item.quantity : 0;
//     }

//     renderProducts() {
//         this.products.forEach(product => {
//             const qty = this.getCartQuantity(product.variantId);
//             console.log("Variant:", product.variantId, "Qty:", qty, "Max:", product.maxQty);
//             let wrapper = product.form.querySelector('.amazon-button-wrapper');
//             if (!wrapper) {
//                 wrapper = document.createElement('div');
//                 wrapper.className = 'amazon-button-wrapper';
//                 product.button.parentNode.insertBefore(wrapper, product.button);
//                 wrapper.appendChild(product.button);
//             }

//             // Remove any existing qty control
//             const existingQty = wrapper.querySelector('.amazon-qty');
//             if (existingQty) {
//                 existingQty.remove();
//             }

//             if (qty > 0) {
//                 product.button.style.display = 'none';
//                 const maxQty = product.maxQty;

//                 wrapper.insertAdjacentHTML('beforeend', this.createQuantityControl(qty, maxQty));
//                 console.log("Qty control inserted", wrapper);
//             } else {
//                 product.button.style.display = '';
//             }
//         });
//     }

//     createQuantityControl(qty, maxQty) {
//         let options = '';
//         for (let i = 1; i <= maxQty; i++) {
//             options += `<option value="${i}" ${i === qty ? 'selected' : ''}>${i}</option>`;
//         }

//         return `<div class="amazon-qty" data-qty="${qty}">
//             <select class="amazon-qty-select" aria-label="Quantity">
//                 ${options}
//             </select>
//         </div>`;
//     }
// }

// document.addEventListener('DOMContentLoaded', () => {
//     new AmazonCollectionCart();
// });

class AmazonCollectionCart {
    constructor() {
        
        this.loading = false;
        this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
        // if (!this.cards.length) return;
        console.log("Amazon Cart Initialized");
        this.init();

        document.addEventListener("cart:refresh", () => {
            this.sync();
        });

        document.addEventListener("cart:updated", () => {
            this.sync();
        });
    }

    async sync() {
        await this.loadCart();
        this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
        this.cacheCards();
        this.renderProducts();
        // Mark dynamically loaded cards as ready
        this.cards.forEach(card => {
            card.classList.add('amazon-ready');
        });
    }

    async init() {
        console.log("Init amazon called");
        await this.loadCart();
        this.cacheCards();
        this.renderProducts();
        this.bindEvents();
        this.cards.forEach(card => {
            card.classList.add("amazon-ready");
        });
    }

    async loadCart() {
        const response = await fetch('/cart.js');
        this.cart = await response.json();
        console.log(this.cart);
    }

    async refreshCartUI() {
        const response = await fetch('?section_id=helper-cart');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Header Count
        document.querySelectorAll('[data-header-cart-count]').forEach(el => {
            const count = doc.querySelector('#AjaxCartForm [data-cart-count]');
            if (count) {
                el.textContent = count.textContent;
            }

        });

        // Header Total
        document.querySelectorAll('[data-header-cart-total]').forEach(el => {
            const total = doc.querySelector('#AjaxCartForm [data-cart-total]');
            if (total) {
                el.textContent = total.textContent;
            }
        });
    }

    async refresh() {
        console.log("Refresh started");
        await Promise.all([
            this.loadCart(),
            this.refreshCartUI()
        ]);
        console.log("Cart after load:", this.cart);
        this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
        this.cacheCards();
        this.renderProducts();
        console.log("Refresh finished");
    }

    async addItem(form) {

        try {
            const variantInput = form.querySelector('input[name="id"]');
            if (!variantInput) {throw new Error("Variant ID not found");}
            const variantId = Number(variantInput.value);
            const properties = {};

            form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(field => {
                const match = field.name.match(/^properties\[(.+)\]$/);
                if (!match) return;
                const propertyName = match[1];
                properties[propertyName] = field.value;
            });

            console.log("Adding product:", {
                variantId,
                properties
            });

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                    properties: properties
                })
            });

            const data = await response.json();
            console.log("Add to cart response:", data);
            if (!response.ok) {
                throw new Error(data.description || 'Failed to add item');
            }
            await this.refresh();
        } catch (error) {
            console.error('Amazon Add Item Error:', error);
        } finally {
            this.loading = false;
            document.body.classList.remove("amazon-cart-loading");

            // Remove button loader
            document.querySelectorAll(
                ".quick_buy_atc_amazon button.amazon-button-loading"
            ).forEach(button => {
                button.classList.remove("amazon-button-loading");
            });
        }
    }

    async changeQuantity(variantId, quantity) {
        const item = this.getCartItem(variantId);
        if (!item) {
            console.warn("Cart item not found:", variantId);
            return;
        }

        console.log("Changing cart quantity:", {
            key: item.key,
            variantId: variantId,
            oldQty: item.quantity,
            newQty: quantity
        });

        try {
            const response = await fetch('/cart/change.js',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: quantity
                    })
                }
            );

            const data = await response.json();
            console.log("Cart change response:", data);
            if (!response.ok) {
                throw new Error(data.description || 'Failed to update cart quantity');
            }

            this.cart = data;
            await this.refreshCartUI();
            this.cards = document.querySelectorAll('.quick_buy_atc_amazon');
            this.cacheCards();
            this.renderProducts();
            setTimeout(() => {
                this.showNextModal();
            }, 1500);
        } catch (error) {
            console.error('Amazon Quantity Update Error:', error);
        } finally {
            this.loading = false;
            document.body.classList.remove("amazon-cart-loading");
            document.querySelectorAll(".amazon-quantity-loading").forEach(wrapper => {
                wrapper.classList.remove("amazon-quantity-loading");
                const select = wrapper.querySelector(".amazon-qty-select");
                if (select) {
                    select.disabled = false;
                }
            });
        }
    }

    async handleClick(e) {
        if (this.loading) return;
        this.loading = true;
        document.body.classList.add("amazon-cart-loading");
        const minusBtn = e.target.closest('.amazon-minus');
        const plusBtn = e.target.closest('.amazon-plus');
        if (!minusBtn && !plusBtn) {
            return;
        }
        e.preventDefault();
        const wrapper = e.target.closest('.amazon-button-wrapper');
        if (!wrapper) return;
        const form = wrapper.closest('form');
        if (!form) return;
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;
        const variantId = Number(variantInput.value);
        const currentQty = this.getCartQuantity(variantId);
        if (minusBtn) {
            const newQty = Math.max(0, currentQty - 1);
            console.log('Minus:', variantId, currentQty, '→', newQty);
            await this.changeQuantity(variantId, newQty);
            return;
        }

        if (plusBtn) {
            const newQty = currentQty + 1;
            console.log('Plus:', variantId, currentQty, '→', newQty);
            await this.changeQuantity(variantId, newQty);
            return;
        }

    }

    bindEvents() {
        if (this.eventsBound) return;
        this.eventsBound = true;

        // ==========================================
        // QUICK BUY / ADD TO CART
        // ==========================================
        document.addEventListener("click", async (e) => {

            // IMPORTANT:
            // Do not let Amazon ATC click handler touch quantity selects.
            if (e.target.closest(".amazon-qty-select")) {
                return;
            }
            const button = e.target.closest(".quick_buy_atc_amazon button[type='submit']");
            if (!button) return;
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (this.loading) return;
            const form = button.closest("form");
            if (!form) return;
            const variantInput = form.querySelector('input[name="id"]');
            if (!variantInput) return;
            const variantId = Number(variantInput.value);
            button.classList.add("amazon-button-loading");
            this.loading = true;
            document.body.classList.add("amazon-cart-loading");
            await this.addItem(form);
        // }, true);
        });

        // ==========================================
        // QUANTITY SELECT CHANGE
        // ==========================================
        document.addEventListener("change", async (e) => {
            const select = e.target.closest(".quick_buy_atc_amazon .amazon-qty-select");
            if (!select) return;
            e.stopPropagation();
            if (this.loading) return;
            const wrapper = select.closest(".amazon-button-wrapper");
            if (!wrapper) return;
            const form = wrapper.closest("form");
            if (!form) return;
            const variantInput = form.querySelector('input[name="id"]');
            if (!variantInput) return;
            const variantId = Number(variantInput.value);
            const newQty = parseInt(select.value, 10);
            if (isNaN(newQty)) return;
            console.log("SELECT CHANGED:", {
                variantId: variantId,
                newQty: newQty
            });

            // Add loading state immediately
            wrapper.classList.add("amazon-quantity-loading");
            select.disabled = true;
            this.loading = true;
            document.body.classList.add("amazon-cart-loading");

            // Let browser render loader before fetch
            await new Promise(resolve => requestAnimationFrame(resolve));
            await this.changeQuantity(variantId, newQty);
        });
    }

    showNextModal() {
        const $closeBtn = $(".close.quick-view-product-close");
        if ($closeBtn.length) {
            $closeBtn.trigger("click");
        }
        $(document.body).find(".close.quick-view-product-close").trigger("click");
        document.body.classList.add("popup_next_open");

        const modalNext = document.getElementById("nextModal");

        if (modalNext) {
            modalNext.style.visibility = "visible";
            modalNext.style.opacity = "1";
        }
    }

    cacheCards() {
        this.products = [];

        this.cards.forEach(card => {
            const form = card.querySelector('form');
            if (!form) return;

            const variantInput = form.querySelector('input[name="id"]');
            if (!variantInput) return;

            const button = form.querySelector('[type="submit"]');
            const inventory = Number(variantInput.dataset.inventory || 0);
            const inventoryManaged = variantInput.dataset.inventoryManaged === 'true';
            const inventoryPolicy = variantInput.dataset.inventoryPolicy;
            let maxQty;

            if (inventoryManaged && inventoryPolicy !== 'continue') {
                maxQty = Math.max(0, inventory);
            } else {
                maxQty = 100;
            }

            this.products.push({
                card,
                form,
                button,
                variantId: Number(variantInput.value),
                maxQty
            });
        });

        console.log("Amazon Products:", this.products);
    }

    getCartItem(variantId) {
        return this.cart.items.find(item => Number(item.id) === Number(variantId));
    }

    getCartQuantity(variantId) {
        const item = this.getCartItem(variantId);
        return item ? item.quantity : 0;
    }

    renderProducts() {

    this.products.forEach(product => {

        const qty = this.getCartQuantity(product.variantId);

        console.log(
            "Varianttitle:",
            product.variantId,
            "Qty:",
            qty,
            "Max:",
            product.maxQty
        );

        let wrapper = product.form.querySelector(
            '.amazon-button-wrapper'
        );

        if (!wrapper) {

            wrapper = document.createElement('div');

            wrapper.className = 'amazon-button-wrapper';

            product.button.parentNode.insertBefore(
                wrapper,
                product.button
            );

            wrapper.appendChild(product.button);
        }

        const existingQty = wrapper.querySelector(
            '.amazon-qty'
        );

        /*
         * ==========================================
         * PRODUCT IS IN CART
         * ==========================================
         */

        if (qty > 0) {

            // Hide Add to Cart
            product.button.style.display = 'none';

            /*
             * IMPORTANT:
             * If select already exists, don't recreate it.
             *
             * This prevents the native select dropdown
             * from closing.
             */
            if (!existingQty) {

                wrapper.insertAdjacentHTML(
                    'beforeend',
                    this.createQuantityControl(
                        qty,
                        product.maxQty
                    )
                );

                console.log(
                    "Qty control inserted",
                    product.variantId
                );

            } else {

                /*
                 * Select already exists.
                 * Only update its value if it isn't
                 * currently being interacted with.
                 */
                const select =
                    existingQty.querySelector(
                        '.amazon-qty-select'
                    );

                if (
                    select &&
                    document.activeElement !== select &&
                    !select.matches(':focus')
                ) {

                    select.value = String(qty);
                }
            }

        }

        /*
         * ==========================================
         * PRODUCT IS NOT IN CART
         * ==========================================
         */

        else {

            product.button.style.display = '';

            if (existingQty) {
                existingQty.remove();
            }

        }

    });
}

    createQuantityControl(qty, maxQty) {
        let options = '';
        for (let i = 1; i <= maxQty; i++) {
            options += `<option value="${i}" ${i === qty ? 'selected' : ''}>${i}</option>`;
        }

        return `<div class="amazon-qty" data-qty="${qty}">
            <select class="amazon-qty-select" aria-label="Quantity">
                ${options}
            </select>
        </div>`;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.amazonCollectionCart = new AmazonCollectionCart();
    initAmazonRecommendedProducts();
});

document.addEventListener('pointerdown', function (e) {

    const select = e.target.closest(
        '.quick_buy_atc_amazon .amazon-qty-select'
    );

    if (!select) return;

    console.log('AMAZON SELECT POINTERDOWN');

    e.stopPropagation();

}, true);

document.addEventListener('mousedown', function (e) {

    const select = e.target.closest(
        '.quick_buy_atc_amazon .amazon-qty-select'
    );

    if (!select) return;

    console.log('AMAZON SELECT MOUSEDOWN');

    e.stopPropagation();

}, true);

function initAmazonRecommendedProducts() {

    const recommendationContainers = document.querySelectorAll(
        '.product-recommendations'
    );

    console.log(
        'Amazon: recommendation containers found:',
        recommendationContainers.length
    );

    if (!recommendationContainers.length) {
        return;
    }

    recommendationContainers.forEach(container => {

        let initialized = false;

        const observer = new MutationObserver(() => {

            // Already initialized — do absolutely nothing.
            if (initialized) {
                return;
            }

            const cards = container.querySelectorAll(
                '.quick_buy_atc_amazon'
            );

            console.log(
                'Amazon: recommended cards found:',
                cards.length
            );

            // Shopify has not inserted the cards yet.
            if (!cards.length) {
                return;
            }

            // Cards are now available.
            initialized = true;

            // STOP observing this recommendation container.
            observer.disconnect();

            console.log(
                'Amazon: recommendation cards loaded — observer stopped'
            );

            // Give Shopify one moment to finish the card DOM.
            setTimeout(() => {

                if (window.amazonCollectionCart) {

                    console.log(
                        'Amazon: syncing recommended products'
                    );

                    window.amazonCollectionCart.sync();

                }

            }, 100);

        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });

        // Also check in case cards already exist.
        const existingCards = container.querySelectorAll(
            '.quick_buy_atc_amazon'
        );

        if (existingCards.length) {

            initialized = true;

            observer.disconnect();

            console.log(
                'Amazon: recommendation cards already present — observer stopped'
            );

            setTimeout(() => {

                if (window.amazonCollectionCart) {
                    window.amazonCollectionCart.sync();
                }

            }, 100);
        }

    });
}

function checkAmazonRecommendedProducts(container) {

    if (!window.amazonCollectionCart) {
        return false;
    }

    const cards = container.querySelectorAll(
        '.quick_buy_atc_amazon'
    );

    console.log(
        'Amazon: recommended cards found:',
        cards.length
    );

    return cards.length > 0;
}

document.addEventListener('shopify:section:load', (event) => {

    console.log(
        'Amazon: Shopify section loaded:',
        event.target
    );

    const recommendationContainer =
        event.target.querySelector?.(
            '.product-recommendations'
        );

    if (!recommendationContainer) {
        return;
    }

    console.log(
        'Amazon: recommendation section loaded'
    );

    initAmazonRecommendedProducts();

});